import React, { useEffect } from "react";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../components/grid-container/GridContainer";
import {
    UiContentWr,
    UiContentCol,
    UiTabContentWr,
} from "../../../components/common/UiPageElements";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import TopHeader from "../../../../_uiComponents/common/custom/header/CustomTopHeader";
import Footer from "../../../../_uiComponents/common/custom/footer/CustomFooter";
import IncentiveBanner from "../views/IncentiveBanner";
import nyImage from "../../../../../styles/img/incentive-st-1.png";
import nyImage2 from "../../../../../styles/img/custom/image-02.png";
import nyImage3 from "../../../../../styles/img/incentive-st-3.png";
import nyImage4 from "../../../../../styles/img/incentive-st-4.png";
import nyImage5 from "../../../../../styles/img/incentive-st-5.png";
import nyImage6 from "../../../../../styles/img/incentive-st-6.png";
import nyImage7 from "../../../../../styles/img/incentive-st-7.png";
import nyImage8 from "../../../../../styles/img/incentive-st-8.png";
import { UiBannerBottomBar } from "../../../components/common/UiBannerBottomBar";
import { IncentivesQuickRead } from "../views/QuickRead";
import { TermsConditions } from "../views/TermsConditions";
import { Faq } from "../views/Faq";
import AbudhabiImage from "../../../../../styles/img/abu-dhabi.png";
import { TickIcon } from "../../../../../styles/img/svg/TickIcon";
import { UiLeftContentRightImageBlock } from "../../../components/common/UiImageBlock";
import { UiAccordion } from "../../../components/common/UiAccordion";
import {
    UiScrollNavWr,
    UiScrollNavItem,
    UiScrollNavLinkItem,
} from "../../../components/common/UiScrollToElements";
import RealTimeCodeEntry from "../views/RealTimeCodeEntry";
import { HowIncentiveWorks } from "./HowIncentiveWorks";
import TeamMemberTable from "./TeamMemberTable";
import RewardChoice from "./RewardChoice";
import UiCustomWr from "../../../../_uiComponents/common/custom/UiCustomWr";
import {
    participantJobRoleIds,
    participantTypeIds,
} from "../../../../../_redux/_constants";
import { useDispatch, useSelector } from "react-redux";
import LeagueTableTeam from "../../../../pages/incentive/views/LeagueTableTeam";
import CurrentCampaigns from "../../../../pages/incentive/views/CurrentCampaigns";
import { useLogContentPageView } from "../../../../pages/common/LogContentPageView";
import { useNavigate } from "react-router-dom";

export default function LeagueIncentives(props) {
    const logPageView = useLogContentPageView();
    let navigate = useNavigate();

    const TableHeaders = [
        { id: 1, th: "Rank" },
        { id: 2, th: "Name" },
        { id: 3, th: "Sales" },
        { id: 4, th: "Location" },
        { id: 5, th: "Department" },
    ];

    const { latestAchievements, thingsToDo, auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    const navClick = () => {
        navigate("/app/campaigns/comms/1");
    };

    const wizardData = [
        {
            id: 1,
            number: "1",
            title: "Step 1",
            content:
                "What percentage of retail visits have an eVHC Carried out? (Target >90%)",
            // status: "active",
        },
        {
            id: 2,
            number: "2",
            title: "Step 2",
            content: "What is your percentage of Red Upsell? (Target >70%)",
        },
        {
            id: 3,
            number: "3",
            title: "Step 3",
            content:
                "Ask why customers are not authorising Red Work? look for trends.",
        },
        {
            id: 5,
            number: "4",
            title: "Step 4",
            content: "Are you promoting the benefits of genuine parts?",
        },
    ];

    const managerWizardData = [
        {
            id: 1,
            number: "1",
            title: "Step 1",
            content:
                "What percentage of retail visits have an eVHC Carried out? (Target >90%)",
            // status: "active",
        },
        {
            id: 2,
            number: "2",
            title: "Step 2",
            content: "What is your percentage of Red Upsell? (Target >70%) ",
        },
        {
            id: 2,
            number: "3",
            title: "Step 3",
            content:
                "Are you asking your Service Team for reasons why customers are not authorising Red Work and recording this? (Keep a log and look for trends) ",
        },
        {
            id: 5,
            number: "4",
            title: "Step 4",
            content: "Is your team selling the benefits of genuine parts?",
        },
    ];
    const termsConditions = [
        {
            id: 1,
            title: "How to participate",
            description:
                "Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.",
        },
        {
            id: 2,
            title: "The clock is ticking",
            description:
                "Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.",
        },
    ];

    const managerFaq = [
        {
            id: 1,
            title: "How many do I need to sell?",
            description:
                "You will be entered into a league and measured against a points system – see campaign copy for points system",
        },
        {
            id: 2,
            title: "How will I know if I have won?",
            description: "You will be notified via email in January 2025",
        },
        {
            id: 3,
            title: "Can I take a guest on the trip if I win?",
            description: (
                <>
                    <p>The trip is for winners only</p>
                </>
            ),
        },
        {
            id: 4,
            title: "Who do I contact if I need support with Équipe?",
            description: (
                <>
                    <p>
                        For Campaign support head to the CNQR platform and
                        select aftersales/aftersales incentive as the topic.
                    </p>
                </>
            ),
        },
    ];

    const areaManagerFaq = [
        {
            id: 1,
            title: "How many does my area need to sell?",
            description:
                "You will be entered into a league and measured against a points system - see campaign copy for points system",
        },
        {
            id: 2,
            title: "How will I know if I have won?",
            description: "You will be notified via email in January 2025",
        },
        {
            id: 3,
            title: "Can I take a guest on the trip if I win?",
            description: (
                <>
                    <p>The trip is for winners only</p>
                </>
            ),
        },
        {
            id: 4,
            title: "Who do I contact if I need support with Équipe?",
            description: (
                <>
                    <p>
                        For Campaign support head to the CNQR platform and
                        select aftersales/aftersales incentive as the topic.
                    </p>
                </>
            ),
        },
    ];

    useEffect(() => {
        logPageView(1, 250);
    }, []);

    return (
        <>
            <UiCustomWr>
                <UiMainWrapper>
                    <IncentiveBanner
                        topText={
                            auth?.userProfileDetails.jobRoleId &&
                            auth?.userProfileDetails.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                            auth?.userProfileDetails.roleId ==
                                participantTypeIds.PARTICIPANT
                                ? "League Incentive"
                                : "Service Manager Incentive"
                        }
                        title="Wear and Tear 
                        Abu Dhabi Incentive"
                        description={
                            auth?.userProfileDetails.jobRoleId &&
                            auth?.userProfileDetails.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                            auth?.userProfileDetails.roleId ==
                                participantTypeIds.PARTICIPANT
                                ? "Drive your Retailers to focus on WEAR & TEAR PARTS. Rank top in the AMAS league to earn your place on our incredible Abu Dhabi trip"
                                : "Focus on wear & tear parts, hit the campaign target and rank top for your league to earn a place on a trip of a lifetime!"
                        }
                        sliderCardImage={AbudhabiImage}
                    />

                    <UiContentWr>
                        <UiTabContentWr>
                            <UiRowContainer fluid="fluid">
                                <UiScrollNavWr>
                                    <UiScrollNavItem
                                        hash="About-the-campaign"
                                        hashText="About the campaign"
                                    />
                                    <UiScrollNavItem
                                        hash="League-table"
                                        hashText="League table"
                                    />
                                    <UiScrollNavItem
                                        hash="T-and-Cs"
                                        hashText="T&Cs"
                                    />
                                    <UiScrollNavItem
                                        hash="FAQs"
                                        hashText="FAQs"
                                    />
                                    <UiScrollNavLinkItem
                                        externalLink="Abu Dhabi"
                                        onClick={navClick}
                                    />
                                </UiScrollNavWr>
                            </UiRowContainer>
                        </UiTabContentWr>
                    </UiContentWr>

                    <UiContentWr>
                        <UiRowContainer fluid="fluid">
                            <UiCol lg="12">
                                <UiContentCol>
                                    <div
                                        className="sb-incentive-leauge-top-left-wr"
                                        id="About-the-campaign"
                                    >
                                        <UiLeftContentRightImageBlock
                                            image1={nyImage}
                                            image2={nyImage2}
                                            image3={nyImage3}
                                            image4={nyImage4}
                                            image5={nyImage5}
                                            image6={nyImage6}
                                            image7={nyImage7}
                                            image8={nyImage8}
                                        >
                                            {auth?.userProfileDetails
                                                .jobRoleId &&
                                                auth?.userProfileDetails
                                                    .jobRoleId ==
                                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                                                auth?.userProfileDetails
                                                    .roleId ==
                                                    participantTypeIds.PARTICIPANT && (
                                                    <div className="sb-incentive-leauge">
                                                        <div className="sb-incetive-right-col__right-section">
                                                            <div className="sb-incetive-right-col__content">
                                                                <h3>
                                                                    How to
                                                                    Participate
                                                                </h3>
                                                                <p>
                                                                    Are you
                                                                    ready to
                                                                    join our
                                                                    top-performing
                                                                    Retailers on
                                                                    an adventure
                                                                    of a
                                                                    lifetime?
                                                                    The Service
                                                                    Managers
                                                                    (one per
                                                                    Area) who
                                                                    outshine the
                                                                    competition
                                                                    in achieving
                                                                    their
                                                                    12-month
                                                                    Wear & Tear
                                                                    goal will
                                                                    win an
                                                                    incredible
                                                                    trip to the
                                                                    luxurious
                                                                    paradise of
                                                                    Abu Dhabi!
                                                                    And you can
                                                                    be right
                                                                    there with
                                                                    them if your
                                                                    Area emerges
                                                                    as the
                                                                    highest
                                                                    achiever
                                                                    based on
                                                                    cumulative
                                                                    points
                                                                    scored.
                                                                </p>
                                                                <p>
                                                                    Retailers
                                                                    have been
                                                                    racking up
                                                                    quarterly
                                                                    points
                                                                    through
                                                                    sales of
                                                                    batteries,
                                                                    wiper
                                                                    blades,
                                                                    brake disks,
                                                                    and brake
                                                                    pads. You
                                                                    can track
                                                                    their
                                                                    progress
                                                                    with the
                                                                    performance
                                                                    tracker
                                                                    below. Now
                                                                    it's time to
                                                                    close out
                                                                    the year
                                                                    with an
                                                                    unstoppable
                                                                    drive for
                                                                    success.
                                                                    Rally your
                                                                    Retailer
                                                                    teams,
                                                                    ensuring
                                                                    every member
                                                                    is primed
                                                                    and ready to
                                                                    excel
                                                                </p>
                                                                <p>
                                                                    To keep
                                                                    everyone
                                                                    laser-focused,
                                                                    each Service
                                                                    Advisor can
                                                                    earn 20,000
                                                                    (£200)
                                                                    reward
                                                                    points in Q4
                                                                    to spend on
                                                                    any vouchers
                                                                    offered
                                                                    through the
                                                                    site. Visit
                                                                    the ÉQUIPE
                                                                    Shop and
                                                                    discover the
                                                                    extensive
                                                                    range of
                                                                    options.
                                                                    Additionally,
                                                                    your Service
                                                                    Managers can
                                                                    earn 'Bonus'
                                                                    points
                                                                    throughout
                                                                    the final
                                                                    quarter by
                                                                    hitting 100%
                                                                    of their
                                                                    Wear & Tear
                                                                    spend
                                                                    targets,
                                                                    becoming the
                                                                    top seller
                                                                    in campaign
                                                                    products,
                                                                    and
                                                                    achieving
                                                                    the highest
                                                                    scores both
                                                                    in your Area
                                                                    and
                                                                    nationally.
                                                                    You can
                                                                    track their
                                                                    performance
                                                                    with the
                                                                    monthly
                                                                    reports
                                                                    below,
                                                                    allowing you
                                                                    to steer
                                                                    your Area
                                                                    towards a
                                                                    triumphant
                                                                    2024.
                                                                </p>
                                                                <p>
                                                                    The table
                                                                    below
                                                                    outlines the
                                                                    quarterly
                                                                    points
                                                                    structure
                                                                    your Area
                                                                    Service
                                                                    Managers are
                                                                    striving
                                                                    towards:
                                                                </p>
                                                                <div className="sb-incentive-tbl-content">
                                                                    <table>
                                                                        <tr>
                                                                            <th>
                                                                                Against
                                                                                Target
                                                                            </th>
                                                                            <th>
                                                                                Points
                                                                                Rewarded
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                138%
                                                                                +
                                                                            </td>
                                                                            <td>
                                                                                20
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                136%
                                                                            </td>
                                                                            <td>
                                                                                19
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                134%
                                                                            </td>
                                                                            <td>
                                                                                18
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                132%
                                                                            </td>
                                                                            <td>
                                                                                17
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                130%
                                                                            </td>
                                                                            <td>
                                                                                16
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                128%
                                                                            </td>
                                                                            <td>
                                                                                15
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                126%
                                                                            </td>
                                                                            <td>
                                                                                14
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                124%
                                                                            </td>
                                                                            <td>
                                                                                13
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                122%
                                                                            </td>
                                                                            <td>
                                                                                12
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                120%
                                                                            </td>
                                                                            <td>
                                                                                11
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                    <table>
                                                                        <tr>
                                                                            <th>
                                                                                Against
                                                                                Target
                                                                            </th>
                                                                            <th>
                                                                                Points
                                                                                Rewarded
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                118%
                                                                            </td>
                                                                            <td>
                                                                                10
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                116%
                                                                            </td>
                                                                            <td>
                                                                                9
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                114%
                                                                            </td>
                                                                            <td>
                                                                                8
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                112%
                                                                            </td>
                                                                            <td>
                                                                                7
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                110%
                                                                            </td>
                                                                            <td>
                                                                                6
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                108%
                                                                            </td>
                                                                            <td>
                                                                                5
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                106%
                                                                            </td>
                                                                            <td>
                                                                                4
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                104%
                                                                            </td>
                                                                            <td>
                                                                                3
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                102%
                                                                            </td>
                                                                            <td>
                                                                                2
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                100%
                                                                            </td>
                                                                            <td>
                                                                                1
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                <p>
                                                                    Good Luck
                                                                    and we hope
                                                                    to welcome
                                                                    you on this
                                                                    stunning
                                                                    winners'
                                                                    trip to Abu
                                                                    Dhabi.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            {auth?.userProfileDetails
                                                .jobRoleId &&
                                                auth?.userProfileDetails
                                                    .jobRoleId ==
                                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                                                auth?.userProfileDetails
                                                    .roleId ==
                                                    participantTypeIds.PARTICIPANT && (
                                                    <div className="sb-incentive-leauge">
                                                        <div className="sb-incetive-right-col__right-section">
                                                            <div className="sb-incetive-right-col__content">
                                                                <h3>
                                                                    Q3 Wear and
                                                                    Tear focus
                                                                    incentive
                                                                </h3>
                                                                <p>
                                                                    As a Service
                                                                    Advisor you
                                                                    can earn a
                                                                    £100 reward
                                                                    bonus when
                                                                    your team
                                                                    achieves its
                                                                    quarterly
                                                                    wear and
                                                                    tear
                                                                    targets.
                                                                    Over 30
                                                                    retailers
                                                                    achieved
                                                                    their wear
                                                                    and tear
                                                                    targets in
                                                                    Q1 & Q2 and
                                                                    there is all
                                                                    to play for
                                                                    as we enter
                                                                    Q3.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="sb-incetive-right-col__content">
                                                            <h5>
                                                                Targets and
                                                                measurement
                                                            </h5>
                                                            <p>
                                                                Targets are
                                                                based on your
                                                                'sales out' at
                                                                PNC value/paying
                                                                entries on four
                                                                key OE (original
                                                                equipment)
                                                                parts:
                                                            </p>
                                                            <ul>
                                                                <li>
                                                                    Brake pads
                                                                </li>
                                                                <li>
                                                                    Brake discs
                                                                </li>
                                                                <li>
                                                                    12v
                                                                    batteries
                                                                </li>
                                                                <li>
                                                                    Wiper blades
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="sb-incetive-right-col__content">
                                                            <h5>Example</h5>
                                                            <p>
                                                                If your total
                                                                value of sales
                                                                out across these
                                                                four parts in
                                                                the period is
                                                                £2,000 and you
                                                                had 400 total
                                                                paying entries,
                                                                your performance
                                                                would be £5.00.
                                                            </p>
                                                            <p>
                                                                Q3 2024 targets
                                                                are based on
                                                                2024 Q1 & Q2
                                                                performance.
                                                                Plus, growth, or
                                                                the minimum
                                                                national target
                                                                of £6 per paying
                                                                entry.
                                                            </p>
                                                            <p>
                                                                Your individual
                                                                retailer targets
                                                                will be sent to
                                                                your Service
                                                                Manager through
                                                                your Renault
                                                                Area Manager, so
                                                                ensure you are
                                                                fully aware of
                                                                the team targets
                                                                by focus product
                                                                that you need to
                                                                hit to attain
                                                                your reward.
                                                            </p>
                                                            <p>
                                                                Results will be
                                                                measured by the
                                                                EDR feed that
                                                                you submit to
                                                                Renault UK
                                                                daily, so
                                                                accuracy is
                                                                vital.
                                                            </p>
                                                        </div>
                                                        <div className="sb-incetive-right-col__content">
                                                            <h5>
                                                                Retailer rewards
                                                            </h5>
                                                            <p>
                                                                Quarterly
                                                                reward: £100 per
                                                                Service Advisor
                                                                that meets the
                                                                targets, paid as
                                                                Points into your
                                                                personal RG
                                                                Équipe account
                                                                for redemption
                                                                against the
                                                                extensive range
                                                                of vouchers that
                                                                are available
                                                                through the
                                                                site.
                                                            </p>
                                                        </div>
                                                        {/* <div className='sb-incetive-right-col__content'>
                                                    <h5>Top performer reward</h5>
                                                    <p> Will you join the best of the network on a three-day celebration trip abroad (‘the Trip’) for the Service Managers who accomplish the highest 12-month achievement against objective?</p>

                                                    <p>The winners will be notified via the Équipe site communications and full details of this opportunity can be found on the dedicate Équipe campaign page.</p>

                                                    <p>In summary, there will be one winner per area. In the event of a tie, there will be two (2) winners, so two Service Managers will attend the Trip. Full details on the trip location and fantastic programme of activities will be shared on Équipe throughout the remainder of 2024. Now, take a moment to view the dedicated campaign page and start planning your route to the greatest event of the year.</p>
                                                    <p></p>
                                                </div> */}

                                                        {/* <UiAccordion items={termsConditions} defaultActiveKey/> */}
                                                    </div>
                                                )}

                                            {auth?.userProfileDetails
                                                .jobRoleId &&
                                                auth?.userProfileDetails
                                                    .jobRoleId ==
                                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                                                auth?.userProfileDetails
                                                    .roleId ==
                                                    participantTypeIds.PARTICIPANT && (
                                                    <div className="sb-incentive-leauge">
                                                        <div className="sb-incetive-right-col__right-section">
                                                            <div className="sb-incetive-right-col__content">
                                                                <h3>
                                                                    How to
                                                                    Participate
                                                                </h3>
                                                                <p>
                                                                    Are you
                                                                    ready to
                                                                    turn your
                                                                    achievements
                                                                    into an
                                                                    unforgettable
                                                                    adventure?
                                                                </p>
                                                                <p>
                                                                    The Service
                                                                    Manager who
                                                                    outperforms
                                                                    their peers
                                                                    and against
                                                                    their
                                                                    12-month
                                                                    objective
                                                                    will win an
                                                                    incredible
                                                                    trip to the
                                                                    luxurious
                                                                    paradise of
                                                                    Abu Dhabi!
                                                                </p>
                                                                <p>
                                                                    Prepare to
                                                                    be enchanted
                                                                    by the
                                                                    breathtaking
                                                                    jewel of the
                                                                    UAE. This
                                                                    stunning
                                                                    destination
                                                                    offers a
                                                                    perfect
                                                                    blend of
                                                                    rich
                                                                    cultural
                                                                    heritage and
                                                                    modern
                                                                    luxury.
                                                                </p>
                                                                <p>
                                                                    Immerse
                                                                    yourself in
                                                                    cultural
                                                                    wonders,
                                                                    exquisite
                                                                    cuisine and
                                                                    dive into
                                                                    thrilling
                                                                    adventures
                                                                    from dune
                                                                    bashing to
                                                                    speed boats!{" "}
                                                                </p>
                                                                <p>
                                                                    You will be
                                                                    entered into
                                                                    a league and
                                                                    measured
                                                                    against the
                                                                    below points
                                                                    system:
                                                                </p>
                                                                <div className="sb-incentive-tbl-content">
                                                                    <table>
                                                                        <tr>
                                                                            <th>
                                                                                Against
                                                                                Target
                                                                            </th>
                                                                            <th>
                                                                                Points
                                                                                Rewarded
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                138%
                                                                                +
                                                                            </td>
                                                                            <td>
                                                                                20
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                136%
                                                                            </td>
                                                                            <td>
                                                                                19
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                134%
                                                                            </td>
                                                                            <td>
                                                                                18
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                132%
                                                                            </td>
                                                                            <td>
                                                                                17
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                130%
                                                                            </td>
                                                                            <td>
                                                                                16
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                128%
                                                                            </td>
                                                                            <td>
                                                                                15
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                126%
                                                                            </td>
                                                                            <td>
                                                                                14
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                124%
                                                                            </td>
                                                                            <td>
                                                                                13
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                122%
                                                                            </td>
                                                                            <td>
                                                                                12
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                120%
                                                                            </td>
                                                                            <td>
                                                                                11
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                    <table>
                                                                        <tr>
                                                                            <th>
                                                                                Against
                                                                                Target
                                                                            </th>
                                                                            <th>
                                                                                Points
                                                                                Rewarded
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                118%
                                                                            </td>
                                                                            <td>
                                                                                10
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                116%
                                                                            </td>
                                                                            <td>
                                                                                9
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                114%
                                                                            </td>
                                                                            <td>
                                                                                8
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                112%
                                                                            </td>
                                                                            <td>
                                                                                7
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                110%
                                                                            </td>
                                                                            <td>
                                                                                6
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                108%
                                                                            </td>
                                                                            <td>
                                                                                5
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                106%
                                                                            </td>
                                                                            <td>
                                                                                4
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                104%
                                                                            </td>
                                                                            <td>
                                                                                3
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                102%
                                                                            </td>
                                                                            <td>
                                                                                2
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                100%
                                                                            </td>
                                                                            <td>
                                                                                1
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                                <p>
                                                                    The top
                                                                    Service
                                                                    Manager in
                                                                    each area
                                                                    will be
                                                                    notified via
                                                                    email in
                                                                    January
                                                                    2025.
                                                                </p>
                                                                <p>
                                                                    Stay tuned
                                                                    for more
                                                                    details
                                                                    about this
                                                                    exciting
                                                                    trip,
                                                                    planned for
                                                                    Q1 2025.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                        </UiLeftContentRightImageBlock>
                                    </div>
                                </UiContentCol>
                            </UiCol>
                        </UiRowContainer>
                    </UiContentWr>

                    <UiContentWr id="League-table">
                        <UiRowContainer
                            fluid="fluid"
                            className="sb-league-tabl-sec"
                        >
                            <UiCol lg="12">
                                <UiSingleRow>
                                    <UiCol lg="12" xl="12">
                                        <LeagueTableTeam />
                                    </UiCol>
                                </UiSingleRow>
                            </UiCol>
                        </UiRowContainer>
                    </UiContentWr>

                    {/* <UiContentWr >
                        <UiRowContainer fluid="fluid" className="sb-league-tabl-sec">
                            <UiCol lg="12">
                                <UiContentCol>
                                    <UiSingleRow>
                                        <UiCol lg="12" xl="12">
                                            <TeamMemberTable />
                                        </UiCol>
                                    </UiSingleRow>
                                </UiContentCol>
                            </UiCol>
                        </UiRowContainer>
                    </UiContentWr> */}
                    {auth?.userProfileDetails.jobRoleId &&
                    auth?.userProfileDetails.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                        <HowIncentiveWorks wizardData={wizardData} />
                    ) : (
                        <HowIncentiveWorks wizardData={managerWizardData} />
                    )}

                    {/* <IncentivesQuickRead  className="sb-ins-lg-wiz-4step" /> */}
                    {/* <RewardChoice /> */}
                    <span id="T-and-Cs"></span>
                    <TermsConditions />
                    <span id="FAQs"></span>

                    {auth?.userProfileDetails.jobRoleId &&
                    auth?.userProfileDetails.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                        <Faq items={areaManagerFaq} />
                    ) : (
                        <Faq items={managerFaq} />
                    )}
                    <CurrentCampaigns />
                </UiMainWrapper>
            </UiCustomWr>
        </>
    );
}
